// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"510":"f72e256b","599":"0d3dc8f4"}[chunkId] + ".chunk.css";
};